// product-card-v2
class ProductCardV2 extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.addCompareButton = this.querySelector(".compare-select-button");
    this.productJson = JSON.parse(
      this.querySelector("[data-product-json]").textContent
    );
    this.panel = document.querySelector("product-compare-panel");
    this.remove = this.querySelector("[data-remove]");
    this.addCompareButton.classList.remove("loading");
    this.listenEvents();

    this.swatches = this.querySelectorAll(".product-color-swatch-wrapper .swatch");
    this.listenSwatches();
  }
  listenEvents() {
    this.addCompareButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (this.classList.contains("checked")) {
        this.panel.dispatchEvent(
          new CustomEvent("compare:remove", {
            detail: {
              productHandle: this.productJson.handle,
            },
          })
        );
      } else {
        this.panel.dispatchEvent(
          new CustomEvent("compare:add", {
            detail: {
              productJson: this.productJson,
              productCard: this,
            },
          })
        );
      }
      // console.log("product json", this.productJson);
    });
  }

  // 产品卡片色块切换
  listenSwatches() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        // 获取当前卡片容器
        const card = swatch.closest(".product-card-v2");

        // 清除当前卡片所有 swatch 的 active
        card?.querySelectorAll(".swatch").forEach((s) => s.classList.remove("active"));
        swatch.classList.add("active");

        // 获取当前选中的颜色信息
        const selectedColor = swatch.getAttribute("data");
        const selectedSku = swatch.getAttribute("data-sku");
        const selectedId = swatch.getAttribute("data-id");
        const available = swatch.getAttribute("data-varavailable") === "true";

        // console.log("选中颜色:", selectedColor, "SKU:", selectedSku, "可用:", available, "data-id:", selectedId);

        // 切换当前卡片的图片，使用 data-id 匹配
        const images = card?.querySelectorAll(".product-card__image .variant-img");
        images?.forEach((img) => {
          const imgId = img.getAttribute("data-id");
          img.classList.toggle("active", imgId === selectedId);
        });

        // 切换价格
        const prices = card?.querySelectorAll(".product-card__content .prices-wrapper .prices");
        prices?.forEach((price) => {
          price.classList.toggle("active", price.getAttribute("data-id") === selectedId);
        });

        // 切换变体按钮 active
        const variantButtons = card?.querySelectorAll(".variant-wrapper.quick-add__submit");
        variantButtons?.forEach((btn) => {
          const isActive = btn.getAttribute("data-id") === selectedId;
          btn.classList.toggle("active", isActive);

          // 如果这个按钮是当前选中的
          if (isActive) {
            const addBtn = btn.querySelector("button.addtocart");
            if (addBtn) {
              if (available) {
                btn.classList.remove("disable");
                addBtn.classList.remove("disable");
                addBtn.disabled = false;
              } else {
                btn.classList.add("disable");
                addBtn.classList.add("disable");
                addBtn.disabled = true;
              }
            }
          }
        });


        // 更新当前卡片 form 的 hidden input[id]
        const form = card?.querySelector('.add-to-cart-form2');
        const inputId = form?.querySelector('input[name="id"]');
        if (inputId) {
          inputId.value = selectedId;
          console.log("更新表单变体 ID:", selectedId);
          const activeVariantBtn = card?.querySelector(".variant-wrapper.quick-add__submit.active");
          let index = activeVariantBtn?.getAttribute("data-index");
          if (!index) {
            const swatchIndex = Number.parseInt(swatch.getAttribute("data-index"), 10);
            index = Number.isFinite(swatchIndex) ? String(Math.max(0, swatchIndex - 1)) : "0";
          }
          updateGiftByIndex($(card), index);
        }
      });
    });
  }



  connectedCallback() {
    this.init();
  }
}

customElements.define("product-card-v2", ProductCardV2);

if (!customElements.get("compare-result-item")) {
  customElements.define(
    "compare-result-item",
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.swatches = this.querySelectorAll(".swatch");
        this.initColorSwatch();
        this.listenEvents();
      }
      isMobile() {
        return window.matchMedia("(max-width: 768px)");
      }
      // 产品对比数据
      listenEvents() {
        // 点击色卡切换图片
        this.swatches.forEach((swatch) => {

          swatch.addEventListener("click", () => {
            // 1️⃣ 获取当前点击的 swatch（色块）的库存状态
            // data-varavailable 是自定义属性，标识此变体是否可用（true/false）
            const nowstatus = swatch.getAttribute("data-varavailable") === "true";

            // 2️⃣ 遍历所有 swatch，清除它们的 active 状态，只保留当前点击的为 active
            this.swatches.forEach((_swatch) => {
              if (_swatch != swatch) {
                _swatch.classList.remove("active");
              }
            });

            // 3️⃣ 给当前点击的 swatch 添加 active（若当前还没被激活）
            if (!swatch.classList.contains("active")) {
              swatch.classList.add("active");
            }

            // 4️⃣ 获取当前 swatch 对应的变体 ID（用于匹配图片、价格、按钮）
            const id = swatch.getAttribute("data-id");

            // 5️⃣ 切换产品主图 —— 移除当前 active 图片，显示与当前选中变体对应的图片
            this.querySelector(`.variant-img.active`)?.classList.remove("active");
            this.querySelector(`.variant-img[data-id="${id}"]`).classList.add("active");

            // 6️⃣ 切换价格 —— 移除当前 active 价格，显示当前变体对应的价格
            this.querySelector(`.prices.active`)?.classList.remove("active");
            this.querySelector(`.prices[data-id="${id}"]`).classList.add("active");

            // 切换“BUY NOW”按钮对应的变体（让当前选中变体的按钮 active）
            const variantButtons = this.querySelectorAll(".variant-wrapper.quick-add__submit");
            variantButtons.forEach((btn) => {
              const match = btn.getAttribute("data-id") === id; // 是否匹配当前选中变体
              // 控制 active 状态
              btn.classList.toggle("active", match);
              

              if (match) {
                const addBtn = btn.querySelector("button.addtocart");
                if (addBtn) {
                  const isDisabled = !nowstatus;
                  btn.classList.toggle("disable", isDisabled);     // 给整个 variant-wrapper 加 disable
                  addBtn.classList.toggle("disable", isDisabled); // 给按钮本身加 disable
                  addBtn.disabled = isDisabled;                   // 禁用按钮点击

                  // 修改文案
                  const textSpan = addBtn.querySelector("span");
                  if (textSpan) {
                    textSpan.textContent = nowstatus ? "Jetzt kaufen" : "SOLD OUT";
                  }

                  // 根据 disable 状态隐藏或显示按钮内部的 SVG
                  const svgIcon = addBtn.querySelector("svg");
                  if (svgIcon) {
                    svgIcon.style.display = isDisabled ? "none" : "inline-block";
                  }
                }
              }
            });

            // 同步更新隐藏 input 的 variant id，让加购时提交选中的变体
            const hiddenInput = this.querySelector('.add-to-cart-form2 input[name="id"]');
            if (hiddenInput) hiddenInput.value = id;
          });

        });

        this.querySelectorAll(".other-options-content .o-item").forEach((otherItem) => {
          otherItem.addEventListener("click", () => {
            // 找到当前选项所属的那一组（父容器）
            const group = otherItem.closest(".other-options-content");
            if (!group) return;

            // 清除该组内的 active
            group.querySelectorAll(".o-item.active").forEach((activeItem) => {
              activeItem.classList.remove("active");
            });

            // 设置当前点击项为 active
            otherItem.classList.add("active");

            // 显示所有颜色 swatch
            this.querySelectorAll(".product-color-swatch-wrapper .swatch").forEach(
              (swatch) => {
                swatch.classList.remove("hidden");
              }
            );

            // 重新初始化颜色 swatch
            this.initColorSwatch();
          });
        });

      }
      initColorSwatch() {
        const activeOptions = Array.from(
          this.querySelectorAll(".other-options-content .o-item.active")
        ).map(item => item.getAttribute("data").trim());

        this.querySelectorAll(".product-color-swatch-wrapper .swatch").forEach((swatch) => {
          const swatchData = swatch.getAttribute("data");

          // 情况1：选中 Standard → 隐藏所有带 Mini 的 swatch
          if (activeOptions.includes("Standard") && swatchData.includes("Mini")) {
            swatch.classList.add("hidden");
            return;
          }

          // 过滤掉 Standard 继续匹配其他选项
          const nonStandardOptions = activeOptions.filter(opt => opt !== "Standard");

          // 如果没有非 Standard 选项 → 显示
          if (nonStandardOptions.length === 0) {
            swatch.classList.remove("hidden");
            return;
          }

          // swatch 必须同时包含所有非 Standard active 选项才显示
          const isMatch = nonStandardOptions.every(optionValue => swatchData.includes(optionValue));
          if (isMatch) {
            swatch.classList.remove("hidden");
          } else {
            swatch.classList.add("hidden");
          }
        });




        // 自动激活第一个可见 swatch
        const visibleSwatches = this.querySelectorAll(
          ".product-color-swatch-wrapper .swatch:not(.hidden)"
        );
        if (visibleSwatches.length > 0) {
          // 先清除所有 active
          visibleSwatches.forEach((s) => s.classList.remove("active"));
          // 给第一个可见的 swatch 添加 active
          const firstVisible = visibleSwatches[0];
          firstVisible.classList.add("active");

          // 触发 click同步图片/价格
          firstVisible.click();
        }
      }

    }
  );

  function parseGiftVariants(raw) {
    if (!raw) return [];
  
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      try {
        const decoded = $("<textarea />").html(raw).text();
        const parsed = JSON.parse(decoded);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e2) {
        return [];
      }
    }
  }

  function updateGiftByIndex($root, vindex) {
    if (!$root || !$root.length) return;
  
    const indexNum = Number.parseInt(vindex, 10);
    const safeIndex = Number.isFinite(indexNum) ? indexNum : 0;
  
    const $gifts = $root.find(".event-sale-pre-gift-container");
    if (!$gifts.length) return;
  
    $gifts.each(function () {
      const $gift = $(this);
  
      const variants = parseGiftVariants($gift.attr("data-variants"));
      const matched = variants.find(
        (v) => Number.parseInt(v.index, 10) === safeIndex,
      );
      const fallback = variants.find((v) => Number.parseInt(v.index, 10) === 0);
      const item = matched || fallback;
  
      const percentText = (item && item.gift__inventory_percent) || "0%";
      $gift.find(".event-sale-pre-gift__inventory_quantity").text(percentText);
  
      const widthPercent = Math.max(
        0,
        Math.min(100, Number.parseFloat(percentText) || 0),
      );
      $gift
        .find(".event-sale-pre-gift__inventory_bar_fill")
        .removeAttr("hidden")
        .css("width", widthPercent + "%");
  
      const $imgs = $gift.find(".event-sale-pre-gift__image_item");
      if ($imgs.length) {
        $imgs.attr("data-active", "false");
        const $byIndex = $imgs
          .filter("[data-index='" + safeIndex + "']")
          .first();
        ($byIndex.length ? $byIndex : $imgs.first()).attr(
          "data-active",
          "true",
        );
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // opendots-one默认粉色
  $('.product-card-v2 .product-color-swatch-wrapper .swatch[data-id="52213618377047"]').trigger("click");
  // openfit2+默认灰色
  $('.product-card-v2 .product-color-swatch-wrapper .swatch[data-id="50761443049815"]').trigger("click");
  // openrun pro2默认橙色
  $('.product-card-v2 .product-color-swatch-wrapper .swatch[data-id="48968541503831"]').trigger("click");
  // openfit air默认粉色
  $('.product-card-v2 .product-color-swatch-wrapper .swatch[data-id="48244283900247"]').trigger("click");
});
